import { Map, fromJS } from 'immutable'
import v4 from 'uuid/v4'
import types from './types'
import {
  isQuickReply,
  isTyping,
  isBotMessage,
  isUserMessage,
} from './utils'
import gif from '../img/bot_gif/profile-pic.png';

const initialState = Map(fromJS({
  gif: gif,
  ip: {
    fetching: false,
    address: '',
    error: false,
  },
  messages: [],
  watermark: 0,
  botIsTyping: false,
  quickReply: {
    data: {},
    active: false,
  },
  sendingMessage: false,
  sendingError: false,
  pendingMessages: [],
  config: {},
  user: {
    id: v4(),
  },
}))

const reducer = (state = initialState, action) => {
  switch (action.type) {
  case types.GET_IP_ADDRESS_REQUEST:
    return state
      .setIn(['ip', 'fetching'], true)
      .setIn(['ip', 'error'], false)
      .setIn(['ip', 'address'], '')
  case types.GET_IP_ADDRESS_SUCCESS:
    return state
      .setIn(['ip', 'fetching'], false)
      .setIn(['ip', 'address'], action.payload.ip)
      .setIn(['ip', 'error'], false)
  case types.GET_IP_ADDRESS_FAILURE:
    return state
      .setIn(['ip', 'fetching'], false)
      .setIn(['ip', 'error'], true)
      .setIn(['ip', 'address'], '')

  case types.POST_MESSAGE_REQUEST: {
    return state
      .set('sendingMessage', true)
      .update('pendingMessages', messages => messages.push(action.payload))
      .update('messages', messages => messages.push(action.payload))
      .setIn(['quickReply', 'active'], false)
  }
  case types.POST_MESSAGE_SUCCESS:
    return state
      .set('sendingMessage', false)
  case types.POST_MESSAGE_FAILURE:
    return state
      .set('sendingMessage', false)
      .set('sendingError', true)

  case types.POST_QUICKREPLY_REQUEST: {
    return state
      .set('sendingMessage', true)
      .update('pendingMessages', messages => messages.push(action.payload))
      .update('messages', messages => messages.push(action.payload))
      .setIn(['quickReply', 'active'], false)
  }
  case types.POST_QUICKREPLY_SUCCESS:
    return state
      .set('sendingMessage', false)
  case types.POST_QUICKREPLY_FAILURE:
    return state
      .setIn(['quickReply', 'active'], true)
      .set('sendingMessage', false)
      .set('sendingError', true)

  case types.SET_EMOTION:
    return state.set('gif', {gif: '/img/bot_gif/profile-pic.png'})

  case types.RECEIVE_DATA:
    // console.log("action.payload.activities[0]", action.payload.activities[0]);
    if (isUserMessage(action.payload.activities[0])) {
      return state
    }
    if (isTyping(action.payload.activities[0])) {
      return state
        .set('botIsTyping', true)
    }
    if (isQuickReply(action.payload.activities[0])) {
      return state
        .set('watermark', action.payload.watermark)
        .set('botIsTyping', false)
        .setIn(['quickReply', 'active'], true)
        .update('messages', messages => messages.push({
          ...action.payload.activities[0],
          text: action.payload.activities[0].attachments[0].content.text,
          attachments: null,
          id: v4(),
        }))
        .setIn(['quickReply', 'data'], action.payload.activities[0])
    }
    if (isBotMessage(action.payload.activities[0])) {
      return state
        .set('watermark', action.payload.watermark)
        .set('botIsTyping', false)
        .update('messages', messages => messages.push({
          ...action.payload.activities[0],
          id: v4(),
        }))
    }
    return state
      .set('botIsTyping', false)
      .update('messages', messages => messages.push({
        ...action.payload.activities[0],
        id: v4(),
      }))

  case types.STORE_BOT_DATA:
    return state
      .set('config', fromJS(action.payload))
  default:
    return state
  }
}

export default { global: reducer }

export const getMessages = state => (
  state.global.get('messages').toJS()
)

export const getBotConfig = state => (
  state.global.get('config').toJS()
)

export const getUserId = state => (
  state.global.get('config').toJS().conversationId
)

export const getActiveQuickReply = (state) => {
  const quickReply = state.global.get('quickReply').toJS()
  if (quickReply.active) {
    return quickReply.data
  }
  return false
}

export const getIpAddress = state => state.global.get('ip').toJS().address

export const isBotTyping = state => state.global.get('botIsTyping')

export const activeGifSelector = state => state.global.get('gif')



// WEBPACK FOOTER //
// ./src/redux/index.js